/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {registerEmailJanus} from '../api'

export const useMutationRegisterEmailJanus = createReactQueryMutationHook('registerEmailJanus', registerEmailJanus)
